export const CMS_ARTICLE = {
  "90627": {
    "en": "/help-center/how-do-i-margin-trade-on-phemex",
    "ru": "/ru/help-center/how-do-i-margin-trade-on-phemex",
    "es": "/es/help-center/how-do-i-margin-trade-on-phemex",
    "de": "/de/help-center/wie-handele-ich-mit-margin-auf-phemex-how-to-user-guide",
    "tr": "/tr/help-center/phemexte-nasil-marjin-islem-yaparim",
    "pt": "/pt/help-center/como-faco-para-negociar-com-margem-na-phemex-tutorial-guia-do-usuario"
  },
  "90652": {
    "en": "/help-center/how-do-i-use-hedge-mode",
    "ru": "/ru/help-center/how-do-i-use-hedge-mode",
    "ja": "/ja/help-center/%E3%83%98%E3%83%83%E3%82%B8%E3%83%A2%E3%83%BC%E3%83%89%E3%81%AE%E4%BD%BF%E3%81%84%E6%96%B9",
    "es": "/es/help-center/how-do-i-use-hedge-mode",
    "de": "/de/help-center/wie-verwende-ich-den-hedge-modus",
    "tr": "/tr/help-center/hedge-modunu-nasil-kullanabilirim",
    "pt": "/pt/help-center/how-do-i-use-hedge-mode"
  },
  "90717": {
    "en": "/help-center/how-do-i-use-the-crypto-converter",
    "ru": "/ru/help-center/%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D1%8C%D1%81%D1%8F-%D0%BA%D1%80%D0%B8%D0%BF%D1%82%D0%BE-%D0%BA%D0%BE%D0%BD%D0%B2%D0%B5%D1%80%D1%82%D0%B5%D1%80%D0%BE%D0%BC",
    "ja": "/ja/help-center/%E4%BB%AE%E6%83%B3%E9%80%9A%E8%B2%A8%E7%82%BA%E6%9B%BF%E3%82%B3%E3%83%B3%E3%83%90%E3%83%BC%E3%82%BF%E3%83%BC-crypto-converter-%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AB%E4%BD%BF%E7%94%A8%E3%81%95%E3%82%8C%E3%82%8B%E3%81%AE%E3%81%8B",
    "de": "/de/help-center/wie-verwende-ich-den-crypto-converter",
    "tr": "/tr/help-center/kripto-donusturucuyu-nasil-kullanirim",
    "pt": "/pt/help-center/como-uso-o-conversor-de-criptomoedas"
  },
  "90723": {
    "en": "/help-center/whats-is-the-crypto-converter",
    "ru": "/ru/help-center/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D0%BA%D1%80%D0%B8%D0%BF%D1%82%D0%BE-%D0%BA%D0%BE%D0%BD%D0%B2%D0%B5%D1%80%D1%82%D0%B5%D1%80",
    "ja": "/ja/help-center/crypto-converter%E3%81%A8%E3%81%AF",
    "es": "/es/help-center/que-es-el-convertidor-de-criptomonedas",
    "de": "/de/help-center/was-ist-der-kryptokonverter-crypto-converter",
    "tr": "/tr/help-center/kripto-donusturucu-nedir",
    "pt": "/pt/help-center/o-que-e-o-conversor-de-criptomoedas"
  },
  "90730": {
    "en": "/help-center/how-do-market-orders-fill",
    "ru": "/ru/help-center/%D0%9A%D0%B0%D0%BA-%D0%B2%D1%8B%D0%BF%D0%BE%D0%BB%D0%BD%D1%8F%D1%8E%D1%82%D1%81%D1%8F-%D1%80%D1%8B%D0%BD%D0%BE%D1%87%D0%BD%D1%8B%D0%B5-%D0%BE%D1%80%D0%B4%D0%B5%D1%80%D0%B0",
    "ja": "/ja/help-center/%E6%88%90%E8%A1%8C%E6%B3%A8%E6%96%87%E3%81%AF%E3%81%A9%E3%81%AE%E3%82%88%E3%81%86%E3%81%AB%E6%88%90%E7%AB%8B%E3%81%99%E3%82%8B%E3%81%AE%E3%81%8B",
    "es": "/es/help-center/como-se-llenan-las-ordenes-de-mercado",
    "de": "/de/help-center/wie-werden-marktauftrage-ausgefuhrt",
    "tr": "/tr/help-center/piyasa-emirleri-nasil-gerceklesir",
    "pt": "/pt/help-center/como-as-ordens-a-mercado-sao-executadas"
  },
  "90752": {
    "en": "/help-center/how-is-liquidation-triggered-for-cross-margin-positions",
    "ru": "/ru/help-center/%D0%9A%D0%B0%D0%BA-%D0%B7%D0%B0%D0%BF%D1%83%D1%81%D0%BA%D0%B0%D0%B5%D1%82%D1%81%D1%8F-%D0%BB%D0%B8%D0%BA%D0%B2%D0%B8%D0%B4%D0%B0%D1%86%D0%B8%D1%8F-%D0%B4%D0%BB%D1%8F-%D0%BF%D0%BE%D0%B7%D0%B8%D1%86%D0%B8%D0%B9-%D1%81-%D0%BA%D1%80%D0%BE%D1%81%D1%81-%D0%BC%D0%B0%D1%80%D0%B6%D0%B5%D0%B9",
    "ja": "/ja/help-center/%E6%A7%98%E3%80%85%E3%81%AA%E6%9D%A1%E4%BB%B6%E4%B8%8B%E3%81%AB%E3%81%8A%E3%81%91%E3%82%8B%E3%82%AF%E3%83%AD%E3%82%B9%E3%83%9E%E3%83%BC%E3%82%B8%E3%83%B3%E3%83%9D%E3%82%B8%E3%82%B7%E3%83%A7%E3%83%B3%E3%81%AE%E6%B8%85%E7%AE%97%E5%87%A6%E7%90%86%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6",
    "es": "/es/help-center/como-se-activa-la-liquidacion-para-posiciones-de-margen-cruzado-cross-margin",
    "de": "/de/help-center/wie-wird-die-liquidation-fur-cross-margin-positionen-ausgelost",
    "tr": "/tr/help-center/capraz-marj-pozisyonlarinda-likidasyon-nasil-tetiklenir",
    "pt": "/pt/help-center/como-a-liquidacao-e-acionada-para-posicoes-de-margem-cruzada"
  },
  "90799": {
    "en": "/help-center/what-is-a-bracket-order",
    "ru": "/ru/help-center/%D0%A7%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D0%B1%D1%80%D0%B5%D0%BA%D0%B5%D1%82-%D0%BE%D1%80%D0%B4%D0%B5%D1%80%D1%8B",
    "ja": "/ja/help-center/%E3%83%96%E3%83%A9%E3%82%B1%E3%83%83%E3%83%88%E6%B3%A8%E6%96%87%E3%81%A8%E3%81%AF%E4%BD%95%E3%81%A7%E3%81%99%E3%81%8B",
    "es": "/es/help-center/que-es-una-bracket-orderorden-de-soporte",
    "de": "/de/help-center/was-ist-eine-bracket-order",
    "tr": "/tr/help-center/destekli-emir-bracket-order-nedir",
    "pt": "/pt/help-center/o-que-e-uma-ordem-bracket"
  },
  "90821": {
    "en": "/help-center/how-do-i-change-trading-pairs-symbols",
    "ru": "/ru/help-center/%D0%BA%D0%B0%D0%BA-%D0%B8%D0%B7%D0%BC%D0%B5%D0%BD%D0%B8%D1%82%D1%8C-%D1%82%D0%BE%D1%80%D0%B3%D0%BE%D0%B2%D1%8B%D0%B5-%D0%BF%D0%B0%D1%80%D1%8B-%D1%81%D0%B8%D0%BC%D0%B2%D0%BE%D0%BB%D1%8B",
    "ja": "/ja/help-center/%E5%8F%96%E5%BC%95%E3%83%9A%E3%82%A2%E3%82%B7%E3%83%B3%E3%83%9C%E3%83%AB%E3%82%92%E5%A4%89%E6%9B%B4%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%99%E3%82%8C%E3%81%B0%E3%81%84%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B",
    "es": "/es/help-center/como-alternar-entre-pares-de-negociacion",
    "de": "/de/help-center/wie-andere-ich-handelspaare-symbole",
    "fr": "/fr/help-center/comment-puis-je-changer-les-paires-de-trading-symboles",
    "tr": "/tr/help-center/how-do-i-change-trading-pairs-symbols",
    "pt": "/pt/help-center/como-faco-para-alterar-os-pares-de-negociacao-simbolos"
  },
  "90861": {
    "en": "/help-center/how-do-i-buy-or-sell-a-coin-spot-trading",
    "ru": "/ru/help-center/%D0%BA%D0%B0%D0%BA-%D0%BA%D1%83%D0%BF%D0%B8%D1%82%D1%8C-%D0%B8%D0%BB%D0%B8-%D0%BF%D1%80%D0%BE%D0%B4%D0%B0%D1%82%D1%8C-%D0%BC%D0%BE%D0%BD%D0%B5%D1%82%D1%83-%D1%81%D0%BF%D0%BE%D1%82%D0%BE%D0%B2%D0%B0",
    "ja": "/ja/help-center/%E3%82%B3%E3%82%A4%E3%83%B3%E3%82%92%E8%B3%BC%E5%85%A5%E3%81%BE%E3%81%9F%E3%81%AF%E5%A3%B2%E5%8D%B4%E3%81%99%E3%82%8B%E3%81%AB%E3%81%AF%E3%81%A9%E3%81%86%E3%81%99%E3%82%8C%E3%81%B0%E3%82%88%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B%E7%8F%BE%E7%89%A9%E5%8F%96%E5%BC%95",
    "es": "/es/help-center/como-compro-o-vendo-criptomonedas-en-el-mercado-spot-al-contado",
    "de": "/de/help-center/wie-kaufe-oder-verkaufe-ich-krypto-auf-dem-spotmarkt",
    "fr": "/fr/help-center/comment-acheter-ou-vendre-une-crypto-trading-au-comptant",
    "tr": "/tr/help-center/how-do-i-buy-or-sell-a-coin-spot-trading"
  },
  "90921": {
    "en": "/help-center/what-is-a-close-on-trigger-order",
    "ru": "/ru/help-center/%D1%87%D1%82%D0%BE-%D0%B7%D0%BD%D0%B0%D1%87%D0%B8%D1%82-%D0%B7%D0%B0%D0%BA%D1%80%D1%8B%D1%82%D1%8C-%D0%BD%D0%B0-%D1%82%D1%80%D0%B8%D0%B3%D0%B3%D0%B5%D1%80%D0%B5",
    "ja": "/ja/help-center/%E3%83%88%E3%83%AA%E3%82%AC%E3%83%BC%E6%99%82%E6%B1%BA%E6%B8%88%E6%B3%A8%E6%96%87%E3%81%A8%E3%81%AF",
    "es": "/es/help-center/que-es-una-orden-cerrar-al-activar",
    "de": "/de/help-center/was-ist-eine-close-on-trigger-order",
    "fr": "/fr/help-center/quest-ce-quun-ordre-close-on-trigger",
    "tr": "/tr/help-center/what-is-a-close-on-trigger-order",
    "pt": "/pt/help-center/o-que-e-uma-ordem-close-on-trigger"
  },
  "90960": {
    "en": "/help-center/what-is-a-stop-loss-order",
    "ru": "/ru/help-center/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D1%81%D1%82%D0%BE%D0%BF-%D0%BB%D0%BE%D1%81%D1%81",
    "ja": "/ja/help-center/%E6%90%8D%E5%88%87%E3%82%8A%E6%B3%A8%E6%96%87%E3%81%A8%E3%81%AF%E4%BD%95%E3%81%A7%E3%81%99%E3%81%8B",
    "es": "/es/help-center/que-es-una-orden-stop-loss-stop-de-perdidas",
    "de": "/de/help-center/was-ist-eine-stop-loss-order",
    "fr": "/fr/help-center/quest-ce-quun-ordre-stop-loss",
    "tr": "/tr/help-center/what-is-a-stop-loss-order",
    "pt": "/pt/help-center/o-que-e-uma-ordem-stop-loss"
  },
  "90968": {
    "en": "/help-center/what-are-conditional-orders",
    "ru": "/ru/help-center/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D1%83%D1%81%D0%BB%D0%BE%D0%B2%D0%BD%D1%8B%D0%B5-%D0%BE%D1%80%D0%B4%D0%B5%D1%80%D1%8B",
    "es": "/es/help-center/que-son-las-ordenes-condicionales",
    "de": "/de/help-center/was-sind-conditional-orders",
    "fr": "/fr/help-center/quest-ce-que-les-ordres-conditionnels",
    "tr": "/tr/help-center/what-are-conditional-orders",
    "pt": "/pt/help-center/o-que-sao-ordens-condicionais"
  },
  "91062": {
    "en": "/help-center/what-is-the-insurance-fund-and-auto-deleveraging",
    "ru": "/ru/help-center/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%BE%D0%B9-%D1%84%D0%BE%D0%BD%D0%B4-%D0%B8-%D0%B0%D0%B2%D1%82%D0%BE-%D0%B4%D0%B5%D0%BB%D0%B5%D0%B2%D0%B5",
    "ja": "/ja/help-center/%E4%BF%9D%E9%99%BA%E5%9F%BA%E9%87%91%E3%81%A8%E3%82%AA%E3%83%BC%E3%83%88%E3%83%87%E3%83%AC%E3%83%90%E3%83%AC%E3%83%83%E3%82%B8%E3%81%A8%E3%81%AF",
    "es": "/es/help-center/que-es-el-fondo-de-seguro-y-autodesapalancamiento-autodeleveraging",
    "de": "/de/help-center/was-ist-der-insurance-fund-und-das-auto-deleveraging",
    "fr": "/fr/help-center/quest-ce-que-le-fonds-dassurance-et-le-desendettement-automatique",
    "tr": "/tr/help-center/sigorta-fonu-ve-otomatik-kaldirac-kaldirma-nedir",
    "pt": "/pt/help-center/o-que-e-o-fundo-de-seguranca-e-desalavancagem-automatica"
  },
  "91094": {
    "en": "/help-center/mark-price-and-dual-price-mechanism",
    "ru": "/ru/help-center/%D1%87%D1%82%D0%BE-%D1%82%D0%B0%D0%BA%D0%BE%D0%B5-%D1%86%D0%B5%D0%BD%D0%B0-%D0%BC%D0%B0%D1%80%D0%BA%D0%B8%D1%80%D0%BE%D0%B2%D0%BA%D0%B8-%D0%B8-%D0%BC%D0%B5%D1%85%D0%B0%D0%BD%D0%B8%D0%B7%D0%BC-%D0%B4",
    "ja": "/ja/help-center/%E4%BE%A1%E6%A0%BC%E3%83%9E%E3%83%BC%E3%82%AD%E3%83%B3%E3%82%B0%E4%BA%8C%E9%87%8D%E4%BE%A1%E6%A0%BC%E3%83%A1%E3%82%AB%E3%83%8B%E3%82%BA%E3%83%A0%E3%81%A8%E3%81%AF",
    "es": "/es/help-center/que-es-el-precio-marca-y-mecanismo-de-precio-dual",
    "de": "/de/help-center/was-ist-der-mark-price-und-der-dual-price-mechanismus",
    "fr": "/fr/help-center/quel-est-le-mecanisme-du-prix-de-marque-et-de-double-indication-des-prix",
    "tr": "/tr/help-center/mark-price-and-dual-price-mechanism",
    "pt": "/pt/help-center/o-que-e-o-mark-price-e-o-mecanismo-de-preco-duplo"
  },
  "91102": {
    "en": "/help-center/risk-limit",
    "ru": "/ru/help-center/%D0%BB%D0%B8%D0%BC%D0%B8%D1%82%D1%8B-%D1%80%D0%B8%D1%81%D0%BA%D0%B0",
    "ja": "/ja/help-center/%E3%83%AA%E3%82%B9%E3%82%AF%E5%88%B6%E9%99%90",
    "es": "/es/help-center/limites-de-riesgo",
    "de": "/de/help-center/risikogrenzen",
    "fr": "/fr/help-center/limites-de-risque",
    "tr": "/tr/help-center/risk-limit",
    "pt": "/pt/help-center/limites-de-risco"
  },
  "98031": {
    "en": "/help-center/what-is-profit-reinvestment"
  }
}